import React from 'react';

import './main-b.css';
import Anchor from '../../components/anchor';

import p01 from '../../static/images/p01_ic01.png';
import p02 from '../../static/images/p01_ic02.png';
import p03 from '../../static/images/p01_ic03.png';
import p04 from '../../static/images/p01_ic04.png';
import p05 from '../../static/images/p01_ic05.png';
import p06 from '../../static/images/p01_ic06.png';

import handleGa from '../../utils/handle-ga';

const Ellipse = () => <div className="ellipse" />;

const data = [
  { title: '在线客服', content: '按需付费，基础产品20元起', img: p01, href: '#online-service' },
  { title: '外呼插件', content: '集成在线客服，一键拨打', img: p02, href: '#call-plugin' },
  { title: '音视频通讯', content: '简化语音视频聊天解决方案', img: p03, href: '#audio-video' },
  { title: '在线表单', content: '收集所有信息，一个表单搞定', img: p04, href: '#online-form' },
  { title: '微信客服', content: '深度连接微信，沉淀潜在客户', img: p05, href: '#wechat-agent' },
  { title: '多客助手', content: '企业微信私域流量管理工具', img: p06, href: '#duoke-assistant' }
];

const toUrl = href => (window.location.href = href);

class MainB extends React.Component {
  handleNav = (title, href) => {
    const type = window.sessionStorage.getItem('_FIRST_PAGE_TYPE');
    handleGa('导航', [type, `导航-${title}`]);
    toUrl(href);
  };
  render() {
    return (
      <div className="home-main-b">
        <div className="home-container-b">
          <Ellipse />
          <h3 className="home-main-b-title">与客户互动的新方式</h3>
          <ul className="home-list-icon">
            {data.map(val => {
              const { title, content, img, href } = val;
              return (
                <li key={href} onClick={() => this.handleNav(title, href)}>
                  <img src={img} alt="title" />
                  <div>
                    <h3>{title}</h3>
                    <p>{content}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="online-chat-container">
          <Anchor id="online-service" />
          <h3>在线客服</h3>
          <p>打破坐席限制，基础产品仅需20元</p>
        </div>
      </div>
    );
  }
}

export default MainB;
